module.exports = __webpack_public_path__ + "img/img1.45ec1354.jpg";